export enum Roles {
    StatementsOnly
}
